import React, { useState, useRef } from 'react';
import {Link } from 'react-router-dom';
import { Nav} from 'react-bootstrap';
import CatalogDropdown from './CatalogDropdown';

const CatalogNavItem = () => {
    const [isOpen, setIsOpen] = useState(false);
    const timeoutRef = useRef(null);
    const navItemRef = useRef(null);

    const handleMouseEnter = () => {
        // Очищаем любой существующий таймаут
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
        setIsOpen(true);
    };

    const handleMouseLeave = () => {
        // Устанавливаем таймаут для закрытия меню
        timeoutRef.current = setTimeout(() => {
            setIsOpen(false);
        }, 300);
    };

    // Функция для закрытия меню при клике на категорию
    const handleCategoryClick = () => {
        setIsOpen(false);
    };

    return (
        <div 
            className="nav-item catalog-nav-item position-relative d-none d-lg-block"
            ref={navItemRef}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <Nav.Link 
                as={Link} 
                to="/catalog"
                className={isOpen ? "active" : ""}
            >
                Каталог
            </Nav.Link>
            
            {isOpen && <CatalogDropdown onCategoryClick={handleCategoryClick}/>}
        </div>
    );
};

export default CatalogNavItem;